module.exports = __webpack_public_path__ + "img/up-arrow-circle-outline.2e7b9892.svg";